function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: 0.8,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.908 16.313a5.405 5.405 0 1010.81-.002 5.405 5.405 0 00-10.81.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.114 16.313h-1.801V13.61m-7.206 3.602H1.9a.9.9 0 01-.901-.9V3.702A.902.902 0 011.9 2.8h16.214a.9.9 0 01.9.9v5.855M5.504 1v4.504M14.511 1v4.504M1 7.305h18.015"
}));

function SvgNominationCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23
  }, props), _ref);
}

export default SvgNominationCard;